/** @param {string} contentfulId */
export default function makeContentfulSectionIdAttr(contentfulId) {
  return `contentful-section-${contentfulId}`;
}
